import { invokeApi, postRequest, publicHeaders } from "../components/network/apiclient";
import { publicFavouriteGameEndpoint, publicFavouriteGameLabelEndpoint, publicPublicUserEndpoint } from "./endpoint";

export const fetchPublicFavouriteGames = (gameLinkId, onSuccess, onError, filter) =>
    invokeApi(postRequest(publicFavouriteGameEndpoint.retrievePath(), publicHeaders, { gameLinkId, filter }), onSuccess, onError);

export const fetchPublicLabels = (gameLinkId, onSuccess, onError) =>
    invokeApi(postRequest(publicFavouriteGameLabelEndpoint.retrievePath(), publicHeaders, { gameLinkId }), onSuccess, onError);

export const retrievePublicUserInfo = (gameLinkId, onSuccess, onError) =>
    invokeApi(postRequest(publicPublicUserEndpoint.retrievePath(), publicHeaders, { gameLinkId }), onSuccess, onError);
